import * as momentLib from "moment"
import "moment/locale/nl"

export const defaultCalendarSpec = {
  lastDay: '[gisteren om] LT',
  sameDay: '[vandaag om] LT',
  nextDay: '[morgen om] LT',
  lastWeek: '[afgelopen] dddd [om] LT',
  nextWeek: '[komende ]dddd [om] LT',
  sameElse: 'dddd D MMMM [om] LT'
}

export const endTimeCalendarSpec = {
  lastDay: '[gisteren van] LT',
  sameDay: '[vandaag van] LT',
  nextDay: '[morgen van] LT',
  lastWeek: '[afgelopen] dddd [van] LT',
  nextWeek: '[komende ]dddd [van] LT',
  sameElse: 'dddd D MMMM [van] LT'
}


momentLib.locale("nl", {
  calendar : defaultCalendarSpec
})

export const moment = momentLib

export type Moment = moment.Moment